import { useState } from "react";
import { PagePicker } from "../../components/pagepicker";
import { ContentSetData, ContentStatus } from "../../types/content.types";
import { SMALL_GAMES_LIST } from "../../constants/textcontent";
import { makeUserContentLink, makeNoUserContentLink } from "../../utils/linkbuilder";
import LinkPane from '../../components/linkpane';
import { pageData } from "../../constants/pagedata";

interface PropsType{
    contentStatus:ContentStatus;
    usermail:string;
    contentSetData:ContentSetData;
    isEdited:boolean;
}

const CHOOSE_MSG:string="Choose a page to use this content.";
const SAVE_MSG:string="You need to save this set of content before it can be used.";
const TITLE_SAVE_MSG:string="Enter a title for this content and then click on save.";

const LINKS_MSG:string="Links to games using these images will appear here.";
const LINKS_MSG_TWO:string="A minimum of 5 images are needed.";

const DEFAULT_PAGE:string='vocab';
// const DEFAULT_PAGE:string='';

export const ContentSetLink=function(props:PropsType){
    const [pageSelected, setPageSelected] = useState(DEFAULT_PAGE);

    const pageClick=function(pageTitle:string){
        if(pageTitle!==pageSelected){
            setPageSelected(pageTitle);
        }else{
            setPageSelected('');
        }
    }

    if(props.contentStatus!==ContentStatus.Default)return null;

    // if(props.contentSetData.imsList.length<5)return null;

    let needToSave=props.isEdited===true&&props.usermail!=="";

    let showPicker=needToSave===false;
    let showLink=pageSelected!==''&&needToSave===false;
    
    let myURL="";
    if(props.usermail===""){
        let imsList=props.contentSetData.imsList;
        let txtsList=props.contentSetData.txtsList;
        let audioChosen=1;
        for(let i=0;i<props.contentSetData.options.length;i++){
            if(props.contentSetData.options[i].optID==='audio'){
                audioChosen=props.contentSetData.options[i].optVal;
            }
        }
        myURL=makeNoUserContentLink(pageSelected, imsList, txtsList, audioChosen);
    }else{
        myURL=makeUserContentLink(pageSelected, props.usermail, props.contentSetData.title);
    }

    let dispMsg="";
    let dispMsg2="";
    if(needToSave){
        if(props.contentSetData.title===''){
            dispMsg=TITLE_SAVE_MSG;
        }else{
            dispMsg=SAVE_MSG;
        }
    }else{
        if(pageSelected===""){
            dispMsg=CHOOSE_MSG;
        }else{
            dispMsg="Current page : "+pageData[pageSelected].pageDir.replace(/-/g,' ');
            if(pageSelected==='wordSearch')dispMsg+='  ('+pageData[pageSelected].info+')';
        }
    }

    if(props.contentSetData.imsList.length<5){
        dispMsg=LINKS_MSG;
        dispMsg2=LINKS_MSG_TWO+makeImagesChosenMsg(props.contentSetData.imsList.length);
        showPicker=false;
        showLink=false;
    }


    return(
        <>
            <hr />
            <h3>Link to this content</h3>
            <p>{dispMsg}</p>
            <p>{dispMsg2}</p>
            {showPicker&&<PagePicker
                pageClick={pageClick}
                pageSelected={pageSelected}
                showList={SMALL_GAMES_LIST}/>}
            {showLink&&<LinkPane linkURL={myURL} />}
        </>
    )
};

function makeImagesChosenMsg(numImages:number){
    if(numImages===1){
        return "  Currently "+numImages.toString()+" image has been chosen.";
    }else{
        return "  Currently "+numImages.toString()+" images have been chosen.";
    }
}